module.exports = __webpack_public_path__ + "img/footericon.7e8fb303.png";